import template from './loansDetailNewCreditCapacity.html';
import controller from './loansDetailNewCreditCapacity.controller';
import './loansDetailNewCreditCapacity.scss';

let loansDetailNewCreditCapacityComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansDetailNewCreditCapacityComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailNewCreditCapacity/loansDetailNewCreditCapacity.component.js